module.exports = __webpack_public_path__ + "img/notification.ec228218.png";